function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m56 49c-3.519 0-6.432 2.613-6.92 6h-7.08c-1.103 0-2-.897-2-2v-2c0-3.309-2.691-6-6-6s-6 2.691-6 6v7c0 1.654-1.346 3-3 3s-3-1.346-3-3v-17.049c4.429-.218 8.59-1.86 11.949-4.727 2.901 4.092 7.664 6.776 13.051 6.776 8.822 0 16-7.178 16-16s-7.178-16-16-16c-2.122 0-4.145.424-6 1.178v-2.178c0-3.86-3.141-7-7-7h-3v-1c0-.552-.447-1-1-1h-4c-.553 0-1 .448-1 1v8c0 .552.447 1 1 1h4c.553 0 1-.448 1-1v-1h3c.552 0 1 .449 1 1v6.453c-2.481 2.819-4 6.505-4 10.547 0 1.161.131 2.291.367 3.382-2.655 2.932-6.399 4.618-10.367 4.618-7.72 0-14-6.28-14-14v-11c0-.551.448-1 1-1h3v1c0 .552.447 1 1 1h4c.553 0 1-.448 1-1v-8c0-.552-.447-1-1-1h-4c-.553 0-1 .448-1 1v1h-3c-3.859 0-7 3.14-7 7v11c0 10.69 8.438 19.423 19 19.949v17.051c0 2.757 2.243 5 5 5s5-2.243 5-5v-7c0-2.206 1.794-4 4-4s4 1.794 4 4v2c0 2.206 1.794 4 4 4h7.08c.488 3.387 3.401 6 6.92 6 3.859 0 7-3.14 7-7s-3.141-7-7-7zm-27-40h-2v-6h2zm-16-6h2v6h-2zm21 4h-3v-2h3c2.757 0 5 2.243 5 5v3.165c-.701.407-1.371.86-2 1.365v-4.53c0-1.654-1.346-3-3-3zm13 6c7.72 0 14 6.28 14 14s-6.28 14-14 14-14-6.28-14-14 6.28-14 14-14zm-44 8v-11c0-2.757 2.243-5 5-5h3v2h-3c-1.654 0-3 1.346-3 3v11c0 8.822 7.178 16 16 16 4.134 0 8.066-1.589 11.028-4.409.246.656.522 1.297.848 1.909-3.286 2.9-7.453 4.5-11.876 4.5-9.925 0-18-8.075-18-18zm53 40c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m56 53c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m40.832 28.555 1.044-1.566 2.229 4.459c.162.323.485.535.847.552h.048c.344 0 .665-.177.848-.47l4.135-6.615 2.16 3.6c.18.301.505.485.857.485h4v-2h-3.434l-2.709-4.515c-.179-.298-.5-.482-.849-.485-.356-.032-.672.174-.856.47l-4.056 6.488-2.202-4.405c-.159-.319-.477-.529-.832-.551-.374-.022-.696.147-.895.443l-1.702 2.555h-2.465v2h3c.334 0 .646-.167.832-.445z"
});

var SvgHealthBeauty = function SvgHealthBeauty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_3",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHealthBeauty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/health-beauty.af7b4dbe.svg";
export { ForwardRef as ReactComponent };